import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      text: "Hello! Welcome to Vikash Foundation. How can I help you today?",
      sender: "bot"
    }
  ]);
  const [inputMessage, setInputMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (inputMessage.trim() === '') return;

    // Add user message
    const userMessage = {
      text: inputMessage,
      sender: "user"
    };
    setMessages((previousMessages) => [...previousMessages, userMessage]);
    setInputMessage('');

    // Simulate bot response
    setTimeout(() => {
      const botResponse = {
        text: getBotResponse(inputMessage),
        sender: "bot"
      };
      setMessages(prev => [...prev, botResponse]);
    }, 500);
  };

  const getBotResponse = (message) => {
    const lowerMessage = message.toLowerCase();
    
    if (lowerMessage.includes('hello') || lowerMessage.includes('hi') || lowerMessage.includes('hey')) {
      return "Hello! How can I assist you today?";
    } else if (lowerMessage.includes('donate') || lowerMessage.includes('donation')) {
      return "Thank you for your interest in donating! You can click on the 'Donate Now' button on our website to make a contribution. Your support helps us make a difference!";
    } else if (lowerMessage.includes('program') || lowerMessage.includes('initiative')) {
      return "We have various programs including Education, Health, Disability Support, Good Governance, and Sanitation. Would you like to know more about any specific program?";
    } else if (lowerMessage.includes('contact') || lowerMessage.includes('phone') || lowerMessage.includes('email')) {
      return "You can reach us at +91-674-2548306 or visit our Contact Us page for more information. We're here to help!";
    } else if (lowerMessage.includes('volunteer') || lowerMessage.includes('join')) {
      return "We welcome volunteers! Please visit our 'Join Us' section to learn more about volunteering opportunities, careers, and internships.";
    } else {
      return "Thank you for your message! For more specific information, please visit our website pages or contact us directly. How else can I help?";
    }
  };

  return createPortal(
    <>
      {/* Chat Button */}
      <button 
        className={`chatbot-toggle ${isOpen ? 'chatbot-toggle--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle chatbot"
      >
        <span className="chatbot-toggle__icon">
          {isOpen ? <span className="icon-cancel"></span> : <span className="icon-chat"></span>}
        </span>
        <span className="chatbot-toggle__text">Chat</span>
      </button>

      {/* Chat Window */}
      <div className={`chatbot-window ${isOpen ? 'chatbot-window--open' : ''}`}>
        <div className="chatbot-window__header">
          <div className="chatbot-window__header-content">
            <div className="chatbot-window__avatar">
              <span className="icon-support"></span>
            </div>
            <div className="chatbot-window__header-text">
              <h3>Vikash Support</h3>
              <p>Online</p>
            </div>
          </div>
        </div>

        <div className="chatbot-window__messages">
          {messages.map((msg, index) => (
            <div 
              key={index} 
              className={`chatbot-message chatbot-message--${msg.sender}`}
            >
              <div className="chatbot-message__content">
                {msg.text}
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        <form className="chatbot-window__input-form" onSubmit={handleSendMessage}>
          <input
            type="text"
            className="chatbot-window__input"
            placeholder="Type your message..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
          />
          <button 
            type="submit" 
            className="chatbot-window__send-button"
            aria-label="Send message"
          >
            <span className="icon-send"></span>
          </button>
        </form>
      </div>
    </>,
    document.body
  );
};

export default Chatbot;

